// @flow

import HomepageAboutParadisePoint from './about-paradise-point'

export default HomepageAboutParadisePoint
